import { isDevPanelEnabled, isDevRuntime } from '../../constants/devControls';
import { useRegisterDevSection } from './DevControlsContext';
import { DevControlsDrawer } from './DevControlsDrawer';
import { TeamInviteUiDevHost } from './TeamInviteUiDevHost';
import { AuthDevSection } from './sections/AuthDevSection';
import { EnvironmentDevSection } from './sections/EnvironmentDevSection';
import { FirestoreReadsDevSection } from './sections/FirestoreReadsDevSection';
import { SupportModalDevSection } from './sections/SupportModalDevSection';
import { PhoneGestureDevSection } from './sections/PhoneGestureDevSection';
import { TeamsDevSection } from './sections/TeamsDevSection';

function GlobalDevSections() {
  useRegisterDevSection({
    id: 'environment',
    title: 'Environment',
    description: 'Build flags, query overrides, and .env.local toggles.',
    order: 0,
    tier: 'global',
    enabled: isDevPanelEnabled('environment'),
    render: () => <EnvironmentDevSection />,
  });

  useRegisterDevSection({
    id: 'phoneGestures',
    title: 'Phone gestures',
    description: 'Zoom and text selection on the page you are looking at.',
    order: 1,
    tier: 'global',
    enabled: isDevPanelEnabled('phoneGestures'),
    render: () => <PhoneGestureDevSection />,
  });

  useRegisterDevSection({
    id: 'firestoreReads',
    title: 'Firestore reads',
    description: 'Billed document reads this session, by path shape.',
    order: 2,
    tier: 'global',
    enabled: isDevPanelEnabled('firestoreReads'),
    render: () => <FirestoreReadsDevSection />,
  });

  useRegisterDevSection({
    id: 'auth',
    title: 'Auth',
    description: 'Debug sign-in, the sign-in modal, and the new-player profile prompt.',
    order: 5,
    tier: 'global',
    enabled: isDevPanelEnabled('auth'),
    render: () => <AuthDevSection />,
  });

  useRegisterDevSection({
    id: 'supportModal',
    title: 'Support modal',
    description: 'Ko-fi modal eligibility and force-open helpers.',
    order: 10,
    tier: 'global',
    enabled: isDevPanelEnabled('supportModal'),
    render: () => <SupportModalDevSection />,
  });

  useRegisterDevSection({
    id: 'teams',
    title: 'Teams',
    description: 'Team state, shared collections, and invite sheet UI previews.',
    order: 12,
    tier: 'global',
    enabled: isDevPanelEnabled('teams'),
    render: () => <TeamsDevSection />,
  });

  return null;
}

/** Global DEV drawer trigger and app-wide sections. */
export function DevControlsHost() {
  if (!isDevRuntime()) return null;

  return (
    <>
      <GlobalDevSections />
      <DevControlsDrawer />
      <TeamInviteUiDevHost />
    </>
  );
}
